import Vue from 'vue'
import axios from 'axios'

// state
export const state = {
  isScorePredictionsLoading: false,
  scorePredictions: {},
}

// getters
export const getters = {
  getPredictedScoreForMatch: ({ scorePredictions }) => matchId => scorePredictions[matchId],
}
// mutations
export const mutations = {
  fetchRoundScorePredictionsStarted(state) {
    state.isScorePredictionsLoading = true
  },
  fetchRoundScorePredictionsSuccess(state, { score }) {
    state.isScorePredictionsLoading = false
    score.map((match) => Vue.set(state.scorePredictions, match.match_id, {
      team1score: match.score_team1,
      team2score: match.score_team2,
    }))
  },
  fetchRoundScorePredictionsFailed(state) {
    state.isScorePredictionsLoading = false
  },

}
// actions
export const actions = {
  async fetchRoundScorePredictions({ commit }, { roundId }) {
    let score = null
    try {
      commit('fetchRoundScorePredictionsStarted')
      score = await axios.get(`prediction/score/${roundId}`)
      commit('fetchRoundScorePredictionsSuccess', { roundId, score })
    } catch (e) {
      commit('fetchRoundScorePredictionsFailed')
    }
    return score
  },
  async setMatchScore({ commit }, { matchId, ...params }) {
    const response = await axios.post(`scorePrediction/${matchId}`, params)
    return response
  },
}
